import React from 'react';
import styles from './TopBar.module.scss';
import arrowLeft from '../../../assets/icons/arrow-left.svg';

const TopBar = ({ title, currentStep, totalSteps, onBack }) => {
  return (
    <div className={styles.topBarContainer}>
      <div className={styles.navigationBar}>
        <button className={styles.iconButton} onClick={onBack}>
          <img src={arrowLeft} alt="Back" />
        </button>
        <h2 className={styles.title}>{title}</h2>
        <div className={styles.iconButton} style={{ visibility: 'hidden' }}>
           <img src={arrowLeft} alt="" />
        </div>
      </div>
      {totalSteps > 1 && (
        <div className={styles.progressBar}>
          {Array.from({ length: totalSteps }, (_, i) => (
            <div
              key={i}
              className={`${styles.progressSegment} ${i < currentStep ? styles.active : ''}`}>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default TopBar;
